import { theme } from 'antd';

const lightAccentPalette = [
  '#f7f1ff',
  '#ecddff',
  '#d9baff',
  '#c18cff',
  '#a958ff',
  '#8826ff',
  '#7110e6',
  '#5b0dbb',
  '#460e8c',
  '#32105f',
];
const darkAccentPalette = [
  '#32105f',
  '#460e8c',
  '#5b0dbb',
  '#7110e6',
  '#8826ff',
  '#a45dff',
  '#c18cff',
  '#d9baff',
  '#ecddff',
  '#f7f1ff',
];

export const lightTheme = {
  cssVar: true,
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#8826ff',
    colorInfo: '#06779b',
    colorInfoBg: '#ecfcff',
    colorBgLayout: '#f5f5fa',
    colorBgContainer: '#ffffff',
    fontFamily: "'Merzigo Sans', Arial, sans-serif",
    // Merzigo Sans ships Regular, Medium and Bold; strong text uses Bold (Keyvod prototype).
    fontWeightStrong: 600,
    // Keyvod standard density: 40px controls, 32px small, 48px large.
    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,
    // Checkbox and radio stay 16px (antd derives them from controlHeight otherwise).
    controlInteractiveSize: 16,
    colorChartText: '#74747d',
    colorTertiaryText: 'rgba(85, 85, 93, 0.65)',
    colorBorder: '#d9d9dd',
    borderRadius: 0,
    borderRadiusLG: 0,
    borderRadiusXLG: 0,
    borderRadiusXXLG: 0,
    borderRadiusXXXL: 0,
    borderRadiusSM: 0,
    borderRadiusXS: 0,
    borderRadiusMax: 0,
    colorBgContainerProfile: '#f7f1ff',
    colorBorderContainerProfile: '#d9baff',
    colorCardBrandStroke: '#d9d9dd',
    colorFillAlterSolid: '#eeeeef',
    colorCardBrandStrokeBg: '#ffffff',
    colorMint1: lightAccentPalette[0],
    colorMint2: lightAccentPalette[1],
    colorMint3: lightAccentPalette[2],
    colorMint4: lightAccentPalette[3],
    colorMint5: lightAccentPalette[4],
    colorMint6: lightAccentPalette[5],
    colorMint7: lightAccentPalette[6],
    colorMint8: lightAccentPalette[7],
    colorMint9: lightAccentPalette[8],
    colorMint10: lightAccentPalette[9],
    colorMint: lightAccentPalette[5],
    componentsDashboardComponentColorCardFill: '#ffffff',
    componentDashboardTableHeaderBg: '#eeeeef',
    cardBodyBg: '#f7f1ff',
    // Map colors
    colorMapGeography: '#d9baff',
    colorMapGeographyStroke: '#a958ff',
    colorMapGeographyHover: '#c18cff',
    colorMapMarkerStroke: '#fff',
    // Channel colors for map tooltips
    colorChannel1: '#ff6b6b',
    colorChannel2: '#4ecdc4',
    colorChannel3: '#45b7d1',
    colorChannel4: '#96ceb4',
    colorChannel5: '#feca57',
    colorChannel6: '#ff9ff3',
    colorChannel7: '#54a0ff',
    colorSegmentBg: '#A19F9F',
    colorLink: '#1677FF',
    colorCard: '#ffffff52',
    colorCardBorder: '#8826ff',
    colorCardTitle: '#7110e6',
    colorCardText: '#5b0dbb',
    colorCardSvgIcon1: '#ecddff',
    colorCardSvgIcon2: '#8826ff',
    colorChartBorder: '#a958ff',
    colorBeerYellow: '#FAAD14',
    cardBlueBg: 'rgba(5, 145, 255, 0.1)',
  },
  components: {
    Input: {
      activeBorderColor: '#2f00ff',
      hoverBorderColor: '#9d9da5',
      activeShadow: 'inset 0 0 0 1px #2f00ff',
    },
    InputNumber: {
      activeBorderColor: '#2f00ff',
      hoverBorderColor: '#9d9da5',
      activeShadow: 'inset 0 0 0 1px #2f00ff',
    },
    DatePicker: {
      activeBorderColor: '#2f00ff',
      hoverBorderColor: '#9d9da5',
      activeShadow: 'inset 0 0 0 1px #2f00ff',
    },
    Switch: {
      trackHeight: 20,
      trackMinWidth: 36,
      handleSize: 14,
      trackPadding: 3,
    },
    Upload: {
      colorText: '#8826ff',
    },
    Table: {
      borderRadius: 0,
      headerBorderRadius: 0,
      colorDraftBg: '#f7f1ff',
      colorUnloadedText: '#FF4D4F',
      colorUnloadedBg: '#FFF2F0',
      panelFillBg: '#ffffff',
      panelHeaderBg: 'rgba(0, 0, 0, 0.02)',
      colorLoadingBg: 'rgba(0, 0, 0, 0.04)',
    },
    Typography: {
      colorTextHeading: '#171719',
      colorLink: '#2f00ff',
    },
    Layout: {
      bodyBg: '#f5f5fa',
      headerBg: '#ffffff',
      contentBg: '#f5f5fa',
      footerBg: '#ffffff',
      footerPadding: '16px 32px',
    },
    Modal: {
      borderRadiusLG: 0,
      borderRadiusSM: 0,
    },
    Button: {
      borderRadius: 0,
      borderRadiusSM: 0,
      borderRadiusLG: 0,
      paddingInlineSM: 7,
      contentFontSizeSM: 14,
    },
    Alert: {
      colorInfo: '#1677ff',
      colorInfoBg: '#e6f4ff',
      colorInfoBorder: '#91caff',
    },
    Collapse: {
      padding: 0,
      fontHeight: 24,
      paddingSM: 0,
    },
    Tabs: {
      colorBorderSecondary: '#adafb3',
    },
    Select: {
      activeBorderColor: '#2f00ff',
      hoverBorderColor: '#9d9da5',
      activeOutlineColor: 'transparent',
      optionHeight: 36,
      optionSelectedBg: '#f7f1ff',
      borderRadiusLG: 0,
      borderRadius: 0,
      borderRadiusSm: 0,
      borderRadiusSmXs: 0,
    },
    Link: {
      colorText: '#1677FF',
    },
  },
};

export const darkTheme = {
  cssVar: true,
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#a45dff',
    colorInfo: '#59c9ed',
    colorInfoBg: 'rgba(89, 201, 237, 0.12)',
    colorBgLayout: '#0d0d0f',
    colorBgContainer: '#19191d',
    fontFamily: "'Merzigo Sans', Arial, sans-serif",
    // Merzigo Sans ships Regular, Medium and Bold; strong text uses Bold (Keyvod prototype).
    fontWeightStrong: 600,
    // Keyvod standard density: 40px controls, 32px small, 48px large.
    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,
    // Checkbox and radio stay 16px (antd derives them from controlHeight otherwise).
    controlInteractiveSize: 16,
    colorChartText: '#92929d',
    colorTertiaryText: 'rgba(184, 184, 192, 0.65)',
    colorBorder: '#34343a',
    borderRadius: 0,
    borderRadiusLG: 0,
    borderRadiusXLG: 0,
    borderRadiusXXLG: 0,
    borderRadiusXXXL: 0,
    borderRadiusSM: 0,
    borderRadiusXS: 0,
    borderRadiusMax: 0,
    colorBgContainerProfile: '#241a36',
    colorBorderContainerProfile: 'rgba(164, 93, 255, 0.42)',
    colorCardBrandStroke: '#34343a',
    colorCardBrandStrokeBg: '#19191d',
    colorFillAlterSolid: '#26262a',
    colorMint1: darkAccentPalette[0],
    colorMint2: darkAccentPalette[1],
    colorMint3: darkAccentPalette[2],
    colorMint4: darkAccentPalette[3],
    colorMint5: darkAccentPalette[4],
    colorMint6: darkAccentPalette[5],
    colorMint7: darkAccentPalette[6],
    colorMint8: darkAccentPalette[7],
    colorMint9: darkAccentPalette[8],
    colorMint10: darkAccentPalette[9],
    colorMint: darkAccentPalette[5],
    componentsDashboardComponentColorCardFill: '#19191d',
    componentDashboardTableHeaderBg: '#242429',
    cardBodyBg: '#19191d',
    // Map colors for dark theme
    colorMapGeography: '#241a36',
    colorMapGeographyStroke: '#5b3b80',
    colorMapGeographyHover: '#3a2860',
    colorMapMarkerStroke: '#1f1f1f',
    // Channel colors for map tooltips (darker versions)
    colorChannel1: '#e55555',
    colorChannel2: '#3bb3b3',
    colorChannel3: '#3a9bc1',
    colorChannel4: '#7fb89f',
    colorChannel5: '#e6b547',
    colorChannel6: '#e584e5',
    colorChannel7: '#4a91e6',
    colorSegmentBg: '#6B6969',
    colorLink: '#1668DC',
    colorCard: 'rgba(255, 255, 255, 0.12)',
    colorCardBorder: '#a45dff',
    colorCardTitle: '#c18cff',
    colorCardText: '#d9baff',
    colorCardSvgIcon1: '#241a36',
    colorCardSvgIcon2: '#a45dff',
    colorChartBorder: '#5b0dbb',
    colorBeerYellow: '#FAAD14',
    cardBlueBg: 'rgba(0, 60, 180, 0.15)',
  },
  components: {
    Input: {
      colorBgContainer: '#0d0d0f',
      activeBorderColor: '#c084ff',
      hoverBorderColor: '#55555f',
      activeShadow: 'inset 0 0 0 1px #c084ff',
    },
    InputNumber: {
      activeBorderColor: '#c084ff',
      hoverBorderColor: '#55555f',
      activeShadow: 'inset 0 0 0 1px #c084ff',
    },
    DatePicker: {
      activeBorderColor: '#c084ff',
      hoverBorderColor: '#55555f',
      activeShadow: 'inset 0 0 0 1px #c084ff',
    },
    Switch: {
      trackHeight: 20,
      trackMinWidth: 36,
      handleSize: 14,
      trackPadding: 3,
    },
    Upload: {
      colorText: '#a45dff',
    },
    Table: {
      borderRadius: 0,
      headerBorderRadius: 0,
      colorDraftBg: '#241a36',
      colorUnloadedText: '#DC4446',
      colorUnloadedBg: '#2C1618',
      panelFillBg: '#19191d',
      panelHeaderBg: 'rgba(0, 0, 0, 0.04)',
      colorLoadingBg: 'rgba(0, 0, 0, 0.04)',
    },
    Typography: {
      colorTextHeading: '#f4f4f5',
      colorLink: '#c18cff',
    },
    Layout: {
      bodyBg: '#0d0d0f',
      headerBg: '#19191d',
      contentBg: '#0d0d0f',
      footerBg: '#0d0d0f',
      footerPadding: '16px 32px',
    },
    Modal: {
      borderRadiusLG: 0,
      borderRadiusSM: 0,
    },
    Button: {
      borderRadius: 0,
      borderRadiusSM: 0,
      borderRadiusLG: 0,
      paddingInlineSM: 7,
      contentFontSizeSM: 14,
    },
    Alert: {
      colorInfo: '#1668dc',
      colorInfoBg: '#111a2c',
      colorInfoBorder: '#111a2c',
    },
    Collapse: {
      padding: 0,
      fontHeight: 24,
      paddingSM: 0,
    },
    Tabs: {
      colorBorderSecondary: '#424242',
    },
    Select: {
      activeBorderColor: '#c084ff',
      hoverBorderColor: '#55555f',
      activeOutlineColor: 'transparent',
      optionHeight: 36,
      optionSelectedBg: '#241a36',
      borderRadiusLG: 0,
      borderRadius: 0,
      borderRadiusSm: 0,
      borderRadiusSmXs: 0,
    },
    Link: {
      colorText: '#1668DC',
    },
  },
} as const;
